// @ts-nocheck
import { IconFileText, IconClock, IconCoins } from '@tabler/icons-react';
import Time from '@/utils/time';
import Helper from '@/utils/helper';
import styles from './CustomerZoneHome.module.css';
import { quoteStatusDisplay, MiniCard, MiniRow } from './CustomerZoneShared';

interface Props {
  quotes: any[];
  currencySymbol: string;
  base: string;
  nav: (path: string) => void;
  limit?: number;
}

export default function CustomerZoneQuotesTab({ quotes, currencySymbol, base, nav, limit }: Props) {
  if (!quotes.length) return <p className={styles.emptyNote}>There are no quotes</p>;

  const items = limit ? quotes.slice(0, limit) : quotes;
  return items.map((q, i) => (
    <MiniCard
      key={i}
      href={`/customerzone/viewquote${base}&i=${q.ID}`}
      title={q.QuoteNumber}
      tone={quoteStatusDisplay(q.QuoteStatus).tone}
      statusText={quoteStatusDisplay(q.QuoteStatus).label}
      onClick={() => nav(`/customerzone/viewquote${base}&i=${q.ID}`)}
      rows={<>
        {q.ItemReference && (
          <MiniRow icon={<IconFileText />}>Ref {q.ItemReference}</MiniRow>
        )}
        {q.ExpiryDate && (
          <MiniRow icon={<IconClock />}>
            {Time.toISOString(Time.parseDate(q.ExpiryDate), false, false)}
          </MiniRow>
        )}
        <MiniRow icon={<IconCoins />}>
          <b>{Helper.getCurrencyValue(q.TotalInclusive, currencySymbol)}</b>
        </MiniRow>
      </>}
    />
  ));
}
